import { render, staticRenderFns } from "./LiveChatWidget.vue?vue&type=template&id=dd95b6d2"
import script from "./LiveChatWidget.vue?vue&type=script&lang=js"
export * from "./LiveChatWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports